<div class="main-container">
  <mat-card>
    <mat-card-title>User Information</mat-card-title>
    <mat-card-content>
      <table class="table mt-4">
        <tbody>
        <tr>
          <th><strong>Username</strong></th>
          <td>{{userModel.username}}</td>
        </tr>
        <tr>
          <th><strong>First Name</strong></th>
          <td>{{userModel.firstName}}</td>
        </tr>
        <tr>
          <th><strong>Last Name</strong></th>
          <td>{{userModel.lastName}}</td>
        </tr>
        <tr>
          <th><strong>Email</strong></th>
          <td>{{userModel.email}}</td>
        </tr>
        <tr>
          <th><strong>Phone Number</strong></th>
          <td>{{userModel.phoneNumber | phoneNumber}}</td>
        </tr>
        <tr>
          <th><strong>Extension</strong></th>
          <td>{{userModel.extension}}</td>
        </tr>
        <tr>
          <th><strong>Role</strong></th>
          <td>{{userModel.roleName}}</td>
        </tr>
        <tr>
          <th><strong>Locked</strong></th>
          <td>{{userModel.isLocked | yesno}}</td>
        </tr>
        <tr>
          <th><strong>Activated</strong></th>
          <td>{{userModel.emailConfirmed | yesno}}</td>
        </tr>
        <tr>
          <th><strong>Enabled</strong></th>
          <td>{{userModel.approved | yesno}}</td>
        </tr>
        <!--<tr>
          <th><strong>Notify me by email about new messages</strong></th>
          <td>{{userModel.emailNotificationEnabled | yesno}}</td>
        </tr>-->
        <tr>
          <th><strong>Created On</strong></th>
          <td>{{userModel.createdOn | dateTime: 'M/dd/yyyy hh:mm a'}}</td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
    <!--<mat-card-actions *ngIf="hasEditAccess">
      <a routerLink="{{editUserUrl}}" mat-raised-button color="primary" matTooltip="Edit User">Edit</a>
    </mat-card-actions>-->
  </mat-card>
</div>

<div class="main-container" *ngIf="userModel.messagingNumbers && userModel.messagingNumbers.length > 0">
  <mat-card>
    <mat-card-title>Messaging Numbers</mat-card-title>
    <mat-card-content>
      <table class="table">
        <tbody>
        <!--<tr>
          <th><strong>Number</strong></th>
          <td>{{userModel.enableCounterPath | yesno}}</td>
        </tr>-->
        <tr *ngFor="let item of userModel.messagingNumbers">
          <td>
            <span *ngIf="!hasPhoneNumbersEditAccess">{{item.phoneNumber | phoneNumber}}</span>
            <a style="text-decoration: underline" *ngIf="hasPhoneNumbersEditAccess" [routerLink]="[editPhoneUrl, item.phoneNumberId, 'edit']">{{item.phoneNumber | phoneNumber}}</a>
          </td>
          <td>
            <div fxLayout="row" fxLayoutGap="5px">
              <mat-icon color="primary" *ngIf="item.receiveEmail">check_box</mat-icon>
              <mat-icon *ngIf="!item.receiveEmail">check_box_outline_blank</mat-icon>
              <span>Receive email alerts</span>
            </div>
          </td>
          <td>
            <div fxLayout="row" fxLayoutGap="5px">
              <mat-icon color="primary" *ngIf="item.includeText">check_box</mat-icon>
              <mat-icon *ngIf="!item.includeText">check_box_outline_blank</mat-icon>
              <span>View new messages in email</span>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>
</div>

<div class="main-container" *ngIf="userModel.faxNumbers && userModel.faxNumbers.length > 0">
  <mat-card>
    <mat-card-title>Fax Numbers</mat-card-title>
    <mat-card-content>
      <table class="table">
        <tbody>
        <tr>
          <th><strong>Number</strong></th>
          <th>
            <strong>Receive</strong>
            <mat-icon class="explanation"
                      matTooltip="This user is authorized to receive incoming faxes to this number within the TeleGo Customer Portal.">
              info_outline
            </mat-icon>
          </th>
          <th>
            <strong>Send</strong>
            <mat-icon class="explanation"
                      matTooltip="This user is authorized to send incoming faxes from this number within the TeleGo Customer Portal.">
              info_outline
            </mat-icon>
          </th>
          <th>
            <strong>View All<br>Sent Faxes</strong>
            <mat-icon class="explanation"
                      matTooltip="This user can view all sent faxes for this number within the TeleGo Customer Portal.">
              info_outline
            </mat-icon>
          </th>
          <th>
            <strong>Receive Email<br>Notifications</strong>
            <mat-icon class="explanation"
                      matTooltip="This user will receive emails to notify them of any new, unread faxes sent to this number in their TeleGo Customer Portal. These emails will be sent even if the user is logged in.">
              info_outline
            </mat-icon>
          </th>
        </tr>
        <tr *ngFor="let item of userModel.faxNumbers">
          <td>
            <span *ngIf="!hasPhoneNumbersEditAccess">{{item.phoneNumber | phoneNumber}}</span>
            <a style="text-decoration: underline" *ngIf="hasPhoneNumbersEditAccess" [routerLink]="[editPhoneUrl, item.phoneNumberId, 'edit']">{{item.phoneNumber | phoneNumber}}</a>
          </td>
          <td>
            <mat-icon color="{{item.allowReceive ? 'primary' : undefined}}">
              {{item.allowReceive ? 'check_box' : 'check_box_outline_blank'}}
            </mat-icon>
          </td>
          <td>
            <mat-icon color="{{item.allowSend ? 'primary' : undefined}}">
              {{item.allowSend ? 'check_box' : 'check_box_outline_blank'}}
            </mat-icon>
          </td>
          <td>
            <mat-icon color="{{item.viewAllSend ? 'primary' : undefined}}">
              {{item.viewAllSend ? 'check_box' : 'check_box_outline_blank'}}
            </mat-icon>
          </td>
          <td>
            <mat-icon color="{{item.receiveEmail ? 'primary' : undefined}}">
              {{item.receiveEmail ? 'check_box' : 'check_box_outline_blank'}}
            </mat-icon>
          </td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>Fax To Email Settings</mat-card-title>
    <mat-card-content>
      <table class="table">
        <tbody>
        <tr>
          <th><strong>Number</strong></th>
          <th>
            <strong>Receive</strong>
            <mat-icon class="explanation" matTooltip="This user will receive emails containing incoming faxes to this number.">
              info_outline
            </mat-icon>
          </th>
          <th>
            <strong>Send</strong>
            <a matTooltip="This user will have the ability to send outgoing faxes from this number through their email. Click icon to get more details."
               href="//kb.telego.com/article/113-email-to-fax-service" target="_blank">
              <mat-icon class="explanation">info_outline</mat-icon>
            </a>
          </th>
        </tr>
        <ng-container *ngFor="let numberItem of userModel.faxNumbers">
          <tr *ngFor="let item of numberItem.emailSettings">
            <td>
              <span *ngIf="!hasPhoneNumbersEditAccess">{{numberItem.phoneNumber | phoneNumber}}</span>
              <a style="text-decoration: underline" *ngIf="hasPhoneNumbersEditAccess" [routerLink]="[editPhoneUrl, numberItem.phoneNumberId, 'edit']">{{numberItem.phoneNumber | phoneNumber}}</a>
            </td>
            <td>
              <mat-icon color="{{item.allowReceive ? 'primary' : undefined}}">
                {{item.allowReceive ? 'check_box' : 'check_box_outline_blank'}}
              </mat-icon>
            </td>
            <td>
              <mat-icon color="{{item.allowSend ? 'primary' : undefined}}">
                {{item.allowSend ? 'check_box' : 'check_box_outline_blank'}}
              </mat-icon>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>
</div>

<div class="main-container" *ngIf="hasSoftPhoneModule">
  <mat-card>
    <mat-card-title>TeleGo Desktop App Settings</mat-card-title>
    <mat-card-content>
      <table class="table mt-4">
        <tbody>
        <tr>
          <th><strong>Enabled</strong></th>
          <td>{{userModel.enableCounterPath | yesno}}</td>
        </tr>
        <tr>
          <th><strong>Username</strong></th>
          <td>{{userModel.ccsUserName}}</td>
        </tr>
        <tr>
          <th><strong>Password</strong></th>
          <td>
            <app-show-hide [value]="userModel.counterPathPassword || '&nbsp;'"></app-show-hide>
          </td>
        </tr>
        <tr>
          <th><strong>First Registration</strong></th>
          <td>{{userModel.firstRegistrationTime | unixTime: 'M/dd/yyyy hh:mm a'}}</td>
        </tr>
        <tr>
          <th><strong>Last Login</strong></th>
          <td>{{userModel.lastLoginTime | unixTime: 'M/dd/yyyy hh:mm a'}}</td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
    <!--<mat-card-actions *ngIf="hasEditAccess">
      <a routerLink="{{editUserUrl}}" mat-raised-button color="primary" matTooltip="Edit User">Edit</a>
    </mat-card-actions>-->
  </mat-card>
</div>

<div class="main-container" *ngIf="hasBasicSoftPhoneModule">
  <mat-card>
    <mat-card-title>TeleGo Mobile App Settings</mat-card-title>
    <mat-card-content>
      <table class="table mt-4">
        <tbody>
        <tr>
          <th><strong>Enabled</strong></th>
          <td>{{basicSoftPhoneSummary.isEnabled | yesno}}</td>
        </tr>
        <tr>
          <th><strong>Username</strong></th>
          <td>{{basicSoftPhoneSummary.username}}</td>
        </tr>
        <tr *ngIf="hasProMessagingModule">
          <th><strong>Phone Number For Text Messages</strong></th>
          <td>{{basicSoftPhoneSummary.smsNumberLabel}}</td>
        </tr>
        <tr>
          <th><strong>Password</strong></th>
          <td>
            <app-show-hide [value]="basicSoftPhoneSummary.password || '&nbsp;'"></app-show-hide>
          </td>
        </tr>
        </tbody>
      </table>
      <div *ngIf="basicSoftPhoneSummary.hasPassword">
        <h3>Scan QR Code with mobile device to automatically login to softphone app</h3>
        <img alt="QR Code" src="{{basicSoftPhoneSummary.qrCode}}">
      </div>
    </mat-card-content>
    <!--<mat-card-actions *ngIf="hasEditAccess">
      <a routerLink="{{editUserUrl}}" mat-raised-button color="primary" matTooltip="Edit User">Edit</a>
    </mat-card-actions>-->
  </mat-card>
</div>
<div class="has-edit-action-bar">&nbsp;</div>
<div class="edit-action-bar" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
  <a routerLink="{{editUserUrl}}" mat-raised-button color="primary" matTooltip="Edit User">Edit</a>
</div>
